import axios, { AxiosResponse } from 'axios';
import { AUTH_API_BASE_URL, CUSTOMER_API_BASE_URL, getPartner } from '../../constants';
import { SignupResponse, SignupFormPayload, LoginResponse, VerifiedOTPResponse, LoginFormPayload, SendOTPFormPayload, VerifyOTPFormPayload, ChangePasswordFormPayload } from '../../models/authentication';
import { Partner } from '../../helpers/types';

export default class AuthService {

  static async signup(payload: SignupFormPayload) {
    const { otpVerifiedToken, ...form } = payload;
    const headers = { 'Authorization': `Bearer ${otpVerifiedToken}` };
    const response: AxiosResponse<SignupResponse> = await axios.post(`${CUSTOMER_API_BASE_URL}/v1.0/customer`, form, {
      headers: headers,
    });
    return response.data;
  }

  static async loginRequest(payload: LoginFormPayload): Promise<LoginResponse> {
    const partner = getPartner() || Partner.CIRCLE;
    const loginResponse: AxiosResponse<LoginResponse> = await axios.post(`${AUTH_API_BASE_URL}/v1.0/token?partner=${partner}`, payload);
    return { ...loginResponse.data };
  }

  static async login(payload: LoginFormPayload): Promise<LoginResponse> {
    // TODO:
    try {
      return await this.loginRequest(payload);
    } catch (err) {
      if (getPartner() === Partner.TASSCARE) {
        localStorage.setItem('partner', Partner.CIRCLE);
      } else if (getPartner() === Partner.ARTMED) {
        localStorage.setItem('partner', Partner.ARTMED);
      } else if (getPartner() === Partner.OGATH) {
        localStorage.setItem('partner', Partner.OGATH);
      } else if (getPartner() === Partner.BDMSTH) {
        localStorage.setItem('partner', Partner.BDMSTH);
      } else {
        localStorage.setItem('partner', Partner.TASSCARE);
      }
      return await this.loginRequest(payload); // Login with other partner incase user lands on the page with different partner
    }
  }

  static async changePassword(payload: ChangePasswordFormPayload) {
    const { token, ...form } = payload;
    const headers = { 'Authorization': `Bearer ${token}`, 'X-Owner': `${form.userId || '*'}` };
    const response: AxiosResponse = await axios.put(`${AUTH_API_BASE_URL}/v1.0/user/${form.userId}`, form, { headers: headers });
    return response.data;
  }

  static async sendOTP(payload: SendOTPFormPayload) {
    const response: AxiosResponse = await axios.post(`${AUTH_API_BASE_URL}/v1.0/otp?partner=${getPartner()}`, payload);
    return response.data;
  }

  static async verifyOTP(payload: VerifyOTPFormPayload) {
    const response: AxiosResponse<VerifiedOTPResponse> = await axios.post(`${AUTH_API_BASE_URL}/v1.0/token/otp?partner=${getPartner()}`, payload);
    return response.data;
  }

}